import Alpine from 'alpinejs';
import Vivus from 'vivus';

Alpine.data('rangeHeroCarousel', (slideCount = 1) => ({
    activeSlide: 0,
    totalSlides: slideCount,
    vivusInstances: [],
    vivusAnimated: false,
    moreInfoOpen: false,

    init() {
        this.$nextTick(() => {
            const svgs = this.$el.querySelectorAll('.range-hero__vivus-svg');
            if (svgs.length > 0) {
                this.initVivusObserver(svgs);
            }
        });
    },

    goToSlide(index) {
        this.activeSlide = index;
    },

    nextSlide() {
        this.activeSlide = (this.activeSlide + 1) % this.totalSlides;
    },

    prevSlide() {
        this.activeSlide = (this.activeSlide - 1 + this.totalSlides) % this.totalSlides;
    },

    initVivusObserver(svgElements) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && !this.vivusAnimated) {
                    this.vivusAnimated = true;
                    this.animateSvgLines(svgElements);
                    observer.disconnect();
                }
            });
        }, {
            threshold: 0.2,
        });

        observer.observe(this.$el);
    },

    animateSvgLines(svgElements) {
        svgElements.forEach((svg, index) => {
            const delay = index * 400;

            setTimeout(() => {
                try {
                    svg.classList.add('vivus-active');

                    const vivusInstance = new Vivus(svg, {
                        type: 'oneByOne',
                        duration: 50,
                        animTimingFunction: Vivus.EASE,
                        start: 'autostart',
                    });

                    this.vivusInstances.push(vivusInstance);
                } catch (e) {
                    console.warn('Vivus animation failed for SVG:', e);
                    svg.classList.add('vivus-active');
                }
            }, delay);
        });
    },
}));
